// member-portal/src/components/NavButtons.js — UPDATED: Hide "Refer & Earn" for non-promoters
// All original functionality preserved — only added promoter role check

import React from 'react';
import './NavButtons.css';

const NavButtons = ({ navigateTo, user, activePage, isSuperAdmin = false }) => {
  // If no user, don't render any buttons
  if (!user) return null;

  // If the user is a SuperAdmin, hide the navigation buttons (they use internal tabs)
  if (isSuperAdmin) {
    return null;
  }

  return (
    <div className="nav-buttons">
      <button
        className={activePage === 'dashboard' ? 'active' : ''}
        onClick={() => navigateTo('dashboard')}
      >
        Dashboard
      </button>
      <button
        className={activePage === 'deals' ? 'active' : ''}
        onClick={() => navigateTo('deals')}
      >
        Deals
      </button>
      {user.role === 'Administrator' && (
        <button
          className={activePage === 'organization' ? 'active' : ''}
          onClick={() => navigateTo('organization')}
        >
          Organization
        </button>
      )}
      {user.role !== 'Light' && (
        <button
          className={activePage === 'users' ? 'active' : ''}
          onClick={() => navigateTo('users')}
        >
          Users
        </button>
      )}
      <button
        className={activePage === 'report' ? 'active' : ''}
        onClick={() => navigateTo('report')}
      >
        Reports
      </button>
      <button
        className={activePage === 'billing' ? 'active' : ''}
        onClick={() => navigateTo('billing')}
      >
        Billing
      </button>

      {/* ─────────────────────────────────────────────────────────────
           FIXED: Hide "Refer & Earn" button for non-promoters
           Added role check – fully reversible by commenting out this block
           Only promoters see this button
           ───────────────────────────────────────────────────────────── */}
      {user.role === 'Promoter' && (
        <button
          className={activePage === 'promoters' ? 'active' : ''}
          onClick={() => navigateTo('promoters')}
        >
          Refer & Earn
        </button>
      )}
      {/* ───────────────────────────────────────────────────────────── */}

      {/* ─────────────────────────────────────────────────────────────
           NEW: Become a Promoter button — visible when NOT logged in
           Added ~6 lines – fully reversible by commenting out this block
           ───────────────────────────────────────────────────────────── */}
      {!user && (
        <button onClick={() => navigateTo('promoter-signup')}>
          Become a Promoter
        </button>
      )}
      {/* ───────────────────────────────────────────────────────────── */}
    </div>
  );
};

export default NavButtons;